import { IWorkerData } from '@th-types/worker.type';

export const containsInNetworkBadge = (worker: IWorkerData): boolean => {
  return worker?.features
    ? worker.features.some((f) => f.feature === 'IN_NETWORK_BADGE')
    : false;
};
